import { useState } from "react";
import { Button, Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { sendResetPasswordLink } from "../../../store/actions/clientsAction";
import Popup from "../../common/modal/Popup";
import Loader from "../../common/loader/Loader";
const ResetPasswordClientPopup = ({resetPasswordRec, onHide, resetPasswordModalShow, setresetPasswordModalShow}) => {
    const dispatch = useDispatch();
    const {
        error: apiError,
        isLoader,
    } = useSelector(state => state.clients);

    
    const submitHandler = () => {
        return dispatch(sendResetPasswordLink({
                clientId: resetPasswordRec,
            })).then((payload) => {
                    if(payload?.type === "clients/sendResetPasswordLink/rejected") {
                        return
                    }
                onHide()
                setresetPasswordModalShow(false)
            })
    }

    return (
        <>
            <Popup
                onHide={() => onHide()}
                size="md"
                show={resetPasswordModalShow}
                title={"Resend Reset Password Link"}
                footer={
                    <>
                        <Button variant="outline-secondary model-btn" className="me-4" onClick={(e) => onHide()}>Cancel</Button>
                        <Button className='btn-primary model-btn' onClick={(e) => submitHandler()}>Confirm</Button>
                    </>
                }
            >
                {isLoader && <Loader />}
                {
                    apiError &&
                    <Alert variant={'danger'}>
                        {apiError?.message || 'Access denied! Please try again'}
                    </Alert>
                 }
                <div style={{textAlign: "center"}}>
                    {
                        "Are you sure you want to resend reset password link to this client?"
                    }
                </div>
            </Popup>
        </>
    )
}

export default ResetPasswordClientPopup;